<sim-basic-material-dialog
	(closeClicked)="close({action: 'ok'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-upload', fontSet: 'fad'}"
	[headerText]="T.IMPORT_ARCHIVE_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<input #uploadInput (change)="handleFileInput($event)" accept=".zip" id="upload" style="display: none" type="file" />

		@if (currentSelectedFile) {
			<div class="previewFile">
				{{ currentSelectedFile.name }}
			</div>
		}

		<div class="uploadFilesFirst">
			<div class="uploadBtnns">
				<button (click)="chooseFiles()" [color]="currentSelectedFile ? 'warn' : 'accent'" class="uploadBtn" mat-raised-button>
					{{ (currentSelectedFile ? T.IMPORT_ARCHIVE_DIALOG_CLEAR : T.IMPORT_ARCHIVE_DIALOG_CHOOSE_FILES) | translate }}
				</button>

				<button
					(click)="uploadFiles()"
					[disabled]="!currentSelectedFile"
					class="uploadToSimStation"
					color="accent"
					mat-raised-button
				>
					{{ T.IMPORT_ARCHIVE_DIALOG_UPLOAD | translate }}
				</button>
			</div>
		</div>
	</ng-container>
</sim-basic-material-dialog>
